
function PrivacyPolicy() {
    return(
        <div class="mx-[15%] pt-20 pb-16">
            <div>
                <h1 class='text-center'>Privacy Policy</h1>
                <br />
                <p class='text-center'><strong>Effective Date:</strong>Apr 22, 2025</p>
                <br />

                <p><strong>Rivermouth Data</strong> ("we", "our", or "us") is committed to protecting the privacy and data of our clients. This Privacy Policy explains how we collect, use, store, and safeguard the data we manage on behalf of brands using our cloud-based business intelligence (BI) services.</p>
                <br />
                <h2>1. Information We Collect</h2>
                <p>We house and manage brand-specific data in secure cloud environments. This data is provided directly by our clients for the purpose of powering their BI applications. The types of data may include, but are not limited to:</p>
                <ul>
                    <li>Sales and marketing analytics</li>
                    <li>Customer data, including personally identifiable information (PII)</li>
                    <li>Advertising performance metrics</li>
                    <li>Operational and financial reporting data</li>
                </ul>
                <br />
                <h2>2. How We Use Your Data</h2>
                <p>We use the data solely for the purpose of providing analytics services and BI reporting as directed by the client. This includes:</p>
                <ul>
                    <li>Storing and structuring data for use in dashboards and reports</li>
                    <li>Performing data transformations to support BI functionality</li>
                    <li>Troubleshooting data issues or supporting client-specific requests</li>
                </ul>
                <p><strong>We do not</strong> use, sell, or share client data with third parties for any marketing or commercial purposes.</p>
                <br />
                <h2>3. Data Ownership and Deletion</h2>
                <p>Our clients retain full ownership of their data. At any time, a client may:</p>
                <ul>
                    <li>Request a full export of their data</li>
                    <li>Instruct us to permanently delete all housed data</li>
                    <li>Terminate services and have all associated data purged from our systems</li>
                </ul>
                <p>We will comply with such requests within a commercially reasonable timeframe and confirm completion.</p>
                <br />
                <h2>4. Data Security</h2>
                <p>We maintain strict security protocols to safeguard data, including but not limited to:</p>
                <ul>
                    <li>Encryption at rest and in transit</li>
                    <li>Access control and authentication</li>
                    <li>Regular system audits and monitoring</li>
                </ul>
                <p>We use trusted cloud infrastructure providers that comply with industry-standard security certifications.</p>
                <br />  
                <h2>5. Third-Party Services</h2>
                <p>If we integrate or interact with third-party platforms (e.g., Google Cloud, AWS, or data visualization tools like Looker Studio), we ensure that those services adhere to high standards of security and data protection. No third party has access to your data unless explicitly authorized by you.</p>
                <br />
                <h2>6. California Privacy Rights</h2>
                <p>We comply with applicable California privacy laws. While we are a B2B service and not a consumer-facing platform, we are committed to transparency and data stewardship consistent with the spirit of the California Consumer Privacy Act (CCPA) and its successors.</p>
                <br />
                <h2>7. Changes to This Policy</h2>
                <p>We may update this Privacy Policy as necessary. If material changes are made, we will notify active clients directly or through our website.</p>
                <br />
                <h2>8. Contact Us</h2>
                <p>For any questions, concerns, or data deletion requests, please contact:</p>
                <p>
                    <strong>Rivermouth Data</strong><br />
                    725 W Valerio St, Santa Barbara, CA 93101<br />
                    ryan@rivermouthdata.com<br />   
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;